export default "__VITE_ASSET__lbQDAD9l__"